import { NgModule } from '@angular/core';

// #region all modules
import { AvatarListModule } from '@knz/assembly/avatar-list';
import { CountDownModule } from '@knz/assembly/count-down';
import { DatePickerModule } from '@knz/assembly/date-picker';
import { DownFileModule } from '@knz/assembly/down-file';
import { SEModule } from '@knz/assembly/edit';
import { EllipsisModule } from '@knz/assembly/ellipsis';
import { ErrorCollectModule } from '@knz/assembly/error-collect';
import { ExceptionModule } from '@knz/assembly/exception';
import { FooterToolbarModule } from '@knz/assembly/footer-toolbar';
import { FullContentModule } from '@knz/assembly/full-content';
import { GlobalFooterModule } from '@knz/assembly/global-footer';
import { SGModule } from '@knz/assembly/grid';
import { ImageModule } from '@knz/assembly/image';
import { LodopModule } from '@knz/assembly/lodop';
import { NoticeIconModule } from '@knz/assembly/notice-icon';
import { NumberToChineseModule } from '@knz/assembly/number-to-chinese';
import { PageHeaderModule } from '@knz/assembly/page-header';
import { QRModule } from '@knz/assembly/qr';
import { QuickMenuModule } from '@knz/assembly/quick-menu';
import { ResultModule } from '@knz/assembly/result';
import { ReuseTabModule } from '@knz/assembly/reuse-tab';
import { SidebarNavModule } from '@knz/assembly/sidebar-nav';
import { STModule } from '@knz/assembly/table';
import { TagSelectModule } from '@knz/assembly/tag-select';
import { SVModule } from '@knz/assembly/view';
import { XlsxModule } from '@knz/assembly/xlsx';
import { ZipModule } from '@knz/assembly/zip';
import { LoadingModule } from '@knz/assembly/loading';
import { CardSelfModule } from '@knz/assembly/card-self';
import { CardSubModule } from '@knz/assembly/card-sub'; 
import { CardEmpModule } from '@knz/assembly/card-emp';
import { CardLimitModule } from '@knz/assembly/card-limit';
import { CardItemModule } from '@knz/assembly/card-item'; 
import { CardFishboneModule } from '@knz/assembly/card-fishbone';

const MODULES = [
  ErrorCollectModule,
  FooterToolbarModule,
  SidebarNavModule,
  DownFileModule,
  ImageModule,
  AvatarListModule,
  EllipsisModule,
  GlobalFooterModule,
  ExceptionModule,
  NoticeIconModule,
  PageHeaderModule,
  ResultModule,
  TagSelectModule,
  CountDownModule,
  STModule,
  ReuseTabModule,
  FullContentModule,
  XlsxModule,
  ZipModule,
  NumberToChineseModule,
  LodopModule,
  QuickMenuModule,
  QRModule,
  SVModule,
  SEModule,
  SGModule,
  DatePickerModule,
  LoadingModule,
  CardSelfModule,
  CardSubModule,
  CardEmpModule,
  CardLimitModule,
  CardItemModule, 
  CardFishboneModule
];

@NgModule({ exports: MODULES })
export class KNZAssemblyModule {}
